export default __webpack_public_path__ + "locales/zh-CN/DeleteDialog.json?hash=9feaec93605006d0443267cb1156143c";